import { render, staticRenderFns } from "./ViewerPageDesign.vue?vue&type=template&id=25121cbd&scoped=true"
import script from "./ViewerPageDesign.vue?vue&type=script&lang=js"
export * from "./ViewerPageDesign.vue?vue&type=script&lang=js"
import style0 from "./ViewerPageDesign.vue?vue&type=style&index=0&id=25121cbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25121cbd",
  null
  
)

export default component.exports